import React from 'react';

export const DropDownMenu = ({ closeMenu, animation, style }) => {
  return (
    <div className="drop-down-menu" style={{ ...style, animation: animation }}>
      <a href="#content" className="drop-down-menu-link" onClick={closeMenu}>
        Про мене
        <span className="span-1"></span>
      </a>
      <a
        href="#services-prices"
        className="drop-down-menu-link"
        onClick={closeMenu}
      >
        Ціни{'&'}послуги
        <span className="span-2"></span>
      </a>
      <a href="#video" className="drop-down-menu-link" onClick={closeMenu}>
        Блог
        <span className="span-3"></span>
      </a>
      <a href="#footer" className="drop-down-menu-link" onClick={closeMenu}>
        Контакти
        <span className="span-4"></span>
      </a>
    </div>
  );
};
